import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Input, Form, Button, notification, Flex } from 'antd';

import { MainLogoIcon } from '@icons/index';

import { jwtDecode } from 'jwt-decode';

import { tryParseJson } from '@extensions/utils';
import { exception } from '@extensions/notification';
import { isNewYearAroundUs } from '@extensions/utils';
import { userLoaded } from '@store/actions';

import { IUserSession } from '@src/entities/user-session';

import { UserType } from '@enums/user-type';

import { serverFetch } from '@src/server';

import '@core/auth.css';

interface IAuth {
    appVersion: string | undefined;
}

interface IAuthParams {
    signInLogin: string;
    password: string;
}
const Auth = (props: IAuth) => {
    const { appVersion } = props;

    const navigate = useNavigate();

    const d = useDispatch();

    const [signInForm] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();

    const [loading, setLoading] = useState(false);
    const [ipAddress, setIpAddress] = useState<string>();

    useEffect(() => {
        getIpAddress();

        document.addEventListener('keydown', onKeyDown, false);
        return () => {
            document.removeEventListener('keydown', onKeyDown, false);
            close();
        };
    }, []);

    const getIpAddress = async () => {
        fetch('https://api.ipify.org/?format=json')
            .then((res) => res.json())
            .then((data: any) => {
                setIpAddress(data?.ip);
            })
            .catch((ex) => {});
    };

    const onKeyDown = (e: any) => {
        if (e.keyCode === 13) {
            signInForm.submit();
        }
    };

    const close = () => {
        setLoading(false);
        signInForm.resetFields();
    };

    const onFinish = (entity: IAuthParams) => {
        setLoading(true);

        const data = {
            login: entity.signInLogin,
            password: entity.password,
            ipAddress: ipAddress,
        };

        serverFetch('auth/signin', { method: 'POST', bodyData: data, credentials: 'include' })
            .then((data) => {
                window.accessToken = data.accessToken;

                localStorage.setItem('refreshToken', data.refreshToken);

                const result: any = jwtDecode(data.accessToken);

                let storedBusinessUnit = localStorage.getItem('businessUnit');
                if (!storedBusinessUnit || +storedBusinessUnit != result.businessUnit) {
                    localStorage.setItem('businessUnit', result.businessUnit as any);
                    navigate('/');
                }

                const userSession: IUserSession = {
                    userId: result.userId,
                    fullName: result.fullName,
                    type: +result.type as UserType,
                    permissions: tryParseJson(result.permissions),
                    userSettings: tryParseJson(result.userSettings),

                    useTagRequired: false,
                };

                d(userLoaded(userSession));
                close();
            })
            .catch((ex) => {
                setLoading(false);
                exception(api, 'Ошибка авторизации', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <div className='auth'>
            <Flex className='auth-container' vertical justify='space-between' align='center'>
                <div className='auth-form'>
                    <div className='auth-logo'>
                        {isNewYearAroundUs() && <div className='santa-hat-auth'></div>}
                        <div style={{ color: '#FFFFFF', fontWeight: 700, fontSize: 42, marginTop: 10 }}>ASIA HUB</div>
                        <MainLogoIcon style={{ fontSize: 64, marginBottom: 20 }} />
                    </div>
                    <div className='auth-form-title'>Личный кабинет</div>

                    <Form size={'large'} form={signInForm} initialValues={{ remember: true }} onFinish={onFinish}>
                        <Form.Item
                            name='signInLogin'
                            className='auth-form-item'
                            rules={[{ required: true, message: 'Пожалуйста введите логин' }]}
                            hasFeedback
                        >
                            <Input name='signInLogin' placeholder='Логин' disabled={loading} className='auth-form-item-input' />
                        </Form.Item>
                        <Form.Item name='password' rules={[{ required: true, message: 'Пожалуйста введите пароль' }]} hasFeedback>
                            <Input.Password name='password' placeholder={'Пароль'} disabled={loading} className='auth-form-item-input' />
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button type='primary' htmlType='submit' loading={loading} className='auth-form-btn'>
                                Войти
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                <div className='auth-app-version'>Версия {appVersion}</div>
            </Flex>

            {contextHolder}
        </div>
    );
};

export default Auth;
